import { TResponsiblePersonsForm } from '~/modules/remote-banking-contacts/type.ts';
import { FormProvider } from 'react-hook-form';
import { RemoteBankingContactsResponsiblePersonsForm } from '~/modules/remote-banking-contacts/forms/RemoteBankingContactsResponsiblePersonsForm.tsx';
import { FormButtonGroup } from '~/modules/processing-personal/PersonalDataApplicationForm/components/styled.ts';
import { Button } from '@mui/material';
import { useResponsiblePersonsForm } from '~/modules/remote-banking-contacts/hooks/useHookForms.ts';
import { useSelector } from 'react-redux';
import { infoMessages } from '~/constants/infoMessages.ts';
import { InformationMessageBlock } from '~/modules/identification/components/InformationMessage/InformationMessageBlock.tsx';
import { RootState } from '~/store/store.ts';

export const ResponsiblePersonsStep = ({
  onSubmit,
}: {
  onSubmit: (values: TResponsiblePersonsForm) => void;
}) => {
  const { formPersons } = useSelector((state: RootState) => state.remoteBankingContacts);
  const form = useResponsiblePersonsForm(formPersons);

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <InformationMessageBlock
          informationText={infoMessages.UPDATE_OF_DISTRIBUTOR_DATA_MESSAGE}
        />
        <RemoteBankingContactsResponsiblePersonsForm />
        <FormButtonGroup>
          <Button variant="contained" color="primary" type="submit">
            Продовжити
          </Button>
        </FormButtonGroup>
      </form>
    </FormProvider>
  );
};
